/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentTypes from './AppointmentTypes/index'
import ProvidersAndAssistants from './ProvidersAndAssistants/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filters({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Filters.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Wv2Qg': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Wv2Qg': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ProvidersAndAssistants
  viewPath={`${viewPath}/ProvidersAndAssistants`}
/>
<AppointmentTypes
  viewPath={`${viewPath}/AppointmentTypes`}
/>
</div>
{children}
</React.Fragment>)
}